import * as Sentry from '@sentry/gatsby'

Sentry.init({
  allowUrls: [/https?:\/\/(www\.)?measurlabs\.com/],
  dsn: process.env.GATSBY_SENTRY_DSN,
  integrations: [],
})
